import * as React from "react"

function SvgInput(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x={0.5} y={3.631} width={11} height={6} rx={1.5} stroke="currentColor" />
      <path stroke="currentColor" strokeLinecap="round" d="M2.5 5.631v2" />
    </svg>
  )
}

export default SvgInput
